export default "./images/survio-1OZFF-assets-ordering.png";